/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import type { MunicipalUserInfoState } from '../../structureDefinitions/userState';

import { appConfig } from '../../../../../appConfig';
import { isProductionEnvironment } from '../../../../../utility/environments';

const getInitialState = (): MunicipalUserInfoState => {
    return {
        isShoppingForAnother: appConfig.coopUserSettings.isShoppingForAnother,
        isOrdererMunicipal: appConfig.coopUserSettings.isOrdererMunicipal,
        isShoppingForMunicipal: appConfig.coopUserSettings.isShoppingForMunicipal,
    };
};

const slice = createSlice({
    name: 'municipalUserInfo',
    initialState: getInitialState(),
    reducers: {
        mockShoppingForAnother: (state: MunicipalUserInfoState) => {
            if (!isProductionEnvironment) {
                state.isShoppingForAnother = true;
                state.isShoppingForMunicipal = true;
            }
        },
    },
});

export const { actions: municipalUserInfoActions, reducer: municipalUserStateReducer } = slice;
